import { defineMessages } from 'react-intl';

const ID_PREFIX = 'WacSignupForm.';
export const messages = defineMessages({
  socialSignUpButtonContinueWithGoogle: {
    id: `${ID_PREFIX}socialSignUpButtonContinueWithGoogle`,
    defaultMessage: 'Continue with Google'
  },
  socialSignUpButtonContinueWithMicrosoft: {
    id: `${ID_PREFIX}socialSignUpButtonContinueWithMicrosoft`,
    defaultMessage: 'Continue with Microsoft'
  },
  socialSignUpButtonSignUpWithEmail: {
    id: `${ID_PREFIX}socialSignUpButtonSignUpWithEmail`,
    defaultMessage: 'Sign up with email'
  },
  socialSignUpButtonSignUpWithGoogle: {
    id: `${ID_PREFIX}socialSignUpButtonSignUpWithGoogle`,
    defaultMessage: 'Sign up with Google'
  }
});
